import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface CollapsibleSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  className?: string;
}

/**
 * Reusable collapsible section component
 * Provides consistent expand/collapse functionality across the application
 */
const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  isExpanded,
  onToggle,
  children,
  className = "",
}) => {
  return (
    <div className={className}>
      <button
        onClick={onToggle}
        className="flex items-center justify-between w-full text-left mb-4"
        aria-expanded={isExpanded}
        aria-controls={`section-${title}`}
      >
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        {isExpanded ? (
          <ChevronUp className="w-5 h-5 text-gray-500" />
        ) : (
          <ChevronDown className="w-5 h-5 text-gray-500" />
        )}
      </button>
      {isExpanded && (
        <div id={`section-${title}`} role="region" aria-labelledby={`section-${title}`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
